<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiBellAlertOutline } from "@mdi/js";
export default {
  name: "MdiBellAlertOutline",
  data() {
    return {
      svgPath: mdiBellAlertOutline,
    };
  },
};
</script>
